export function formatDecimalString(value: string, minimumFractionDigits = 0): string {
  const match = /^([+-]?)(\d+)(?:\.(\d+))?$/u.exec(value);
  if (match === null) return value;

  const sign = match[1] ?? '';
  const integer = match[2] ?? '';
  const fraction = match[3] ?? '';
  const groupedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/gu, ',');
  const paddedFraction = fraction.padEnd(Math.max(0, minimumFractionDigits), '0');

  return paddedFraction.length === 0
    ? `${sign}${groupedInteger}`
    : `${sign}${groupedInteger}.${paddedFraction}`;
}
